import React, { FC } from 'react'
import { useTheme } from 'react-jss'
import { LightTheme } from '../theme'
import { IconProps } from './types'

export const Collapse: FC<IconProps> = (props) => {
  const theme: LightTheme = useTheme()
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M17 2L12 7L7 2L17 2Z"
        fill={props.fill || theme.colors.darkBlue}
      />
      <path
        d="M7 22L12 17L17 22H7Z"
        fill={props.fill || theme.colors.darkBlue}
      />
      <rect
        x="4"
        y="11"
        width="16"
        height="2"
        fill={props.fill || theme.colors.darkBlue}
      />
    </svg>
  )
}
